module.exports = __webpack_public_path__ + "img/4.04c44359.webp";